
import React from 'react';
import { NotifyProvider } from '@gx-design/snackbar';
import { authRegisterPage } from './pages/AuthRegisterPage';
import { GtxApp } from 'gtx-react/components/GtxApp/GtxApp';

export const App = () => {
    return (
        <NotifyProvider>
            <GtxApp pages={[authRegisterPage]} />
        </NotifyProvider>
    );

}

